// extracted by mini-css-extract-plugin
module.exports = {"container":"TnC_container__1FGPo","terms":"TnC_terms__WXx6R","acceptButton":"TnC_acceptButton__1iF-N"};